module.exports = __webpack_public_path__ + "img/img_banner_size06.db15a578.svg";